import React, { useState } from 'react';
import { Bubble } from 'tea-component';
import './index.scss';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';
import TextBubbles from '@/pages/home/components/TextBubbles';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import GameImage from '@/pages/home/components/GameImage';

// gameType mobile pc console
export default function GameInfocont(props: any) {
  const {
    data = null,
    // 游戏类型 mobile pc console
    type,
    iconList = null,
    rank = null,
    logoicon,
    onClick = () => { },
    rightClickToJumpHref  /** 右键游戏跳转新链接 */
  } = props;

  const bubbleList = useState<any>([]);
  data?.subtextlist?.map((item: any) => {
    bubbleList.push(item, ', ');
  });
  bubbleList.pop();

  return (
    <ARightClickToJump
      href={addV2Prefix(rightClickToJumpHref)}
      style={{ display: 'inline' }}
    >
      <div
        className={`dbi-gameinfocont 
        ${type ? `dbi-gameinfocont--${type}` : ''}`}
      >
        {rank ? (
          <div className="dbi-gameinfocont-rank">
            {rank <= 3 ? (
              <img
                src={
                  rank == 1
                    ? TipOne
                    : rank == 2
                      ? TipTwo
                      : rank == 3
                        ? TipThree
                        : ''
                }
                alt=""
              />
            ) : (
              <span>{rank}</span>
            )}
          </div>
        ) : (
          ''
        )}
        <div className="dbi-gameinfocont-wrap">
          <div className="dbi-gameinfocont-img">
            <GameImage src={data?.img} entityType={type} />
          </div>
          <div className="dbi-gameinfocont-cont">
            <div className="dbi-gameinfocont-title" onClick={onClick}>
              <TextBubbles text={data?.title} />
              {logoicon ? <img src={logoicon} alt="" /> : ''}
            </div>
            <div className="dbi-gameinfocont-text">
              {data?.icon ? <img src={data?.icon} alt="" /> : ''}
              <div className="dbi-gameinfocont-subtextlist">
                <Bubble dark content={data?.textcontent}>
                  <span>{data?.text}</span>
                </Bubble>

                {/* placement='top-start' */}
                <Bubble dark content={bubbleList} placement="top-start">
                  {data?.subtextlist?.map((item: any, index: any) => {
                    return (
                      <span key={index} className="subtextlist-item">
                        {item}
                      </span>
                    );
                  })}
                </Bubble>
              </div>
            </div>
            {iconList ? (
              <div className="dbi-gameinfocont-icon">
                {iconList.map((item: any, index: any) => {
                  return <img src={item} alt="" />;
                })}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </ARightClickToJump>
  );
}
